export default {
  data() {
    return {
      theCheckedAddress: {},
      ignoreArea: false
    }
  },
  methods: {
    async checkPlace(place, session = null) {
      let placesUrl
      if (place.plusCode) {
        placesUrl = this.$appConfig.api.baseUrl + 'places/open-location-code?code=' + place.code.replace(/\+/g, '%2B')
      } else if (place.coordinates) {
        return this.checkPlaceByCoords(place.coords.split(',')[0].trim(), place.coords.split(',')[1].trim())
      } else if (place.id || (place.place_id && place.google_place_id)) {
        placesUrl = this.$appConfig.api.baseUrl + 'places/' + (place.place_id || place.id)
      } else {
        placesUrl = this.$appConfig.api.baseUrl + 'places'
      }
      return await this.$http.get(placesUrl, {params: {id: place.place_id, address: place.main_text + (place.secondary_text !== '' ? ', ' + place.secondary_text : ''), session_token: session}})
        .then(response => {
          if (response.ok) {
            return response.json().then(json => {
              if (!this.ignoreArea) {
                if (json.in_area !== null) {
                  this.theCheckedAddress = json
                  return json
                } else {
                  let obj = {
                    title: this.$gettext('ERROR'),
                    message: this.$gettext('Sorry, the address is out of our coverage areas.'),
                    type: 'error',
                    customCloseBtnText: this.$gettext('Close')
                  }
                  this.theCheckedAddress = {}
                  this.$root.$children[0].$refs.simplert.openSimplert(obj)
                  return false
                }
              } else {
                this.theCheckedAddress = json
              }
              return json
            })
          }
        }).catch(response => {
          let obj = {
            title: this.$gettext('ERROR'),
            message: this.$gettext('The address is not accurate enough or is incorrect.'),
            type: 'error',
            customCloseBtnText: this.$gettext('Close')
          }
          this.theCheckedAddress = {}
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    },
    async checkPlaces(places, session = null) {
      let found = false
      for (let i = 0; i < places.length; i++) {
        let place = await this.checkPlace(places[i], session)
        console.log(place)
        if (place?.in_area && found === false) {
          found = true
          return place
        }
        this.$root.$children[0].$refs.simplert.justCloseSimplert()
      }
    },
    async checkPlaceByCoords(lat, lng) {
      return await this.$http.get(this.$appConfig.api.baseUrl + 'places/coords', {params: {lat: lat, lng: lng}})
        .then(async response => {
          if (response.ok) {
            return await response.json().then(async json => {
              if (!this.ignoreArea) {
                if (json.in_area !== null) {
                  this.theCheckedAddress = json
                } else {
                  let obj = {
                    title: this.$gettext('ERROR'),
                    message: this.$gettext('Sorry, the address is out of our coverage areas.'),
                    type: 'error',
                    customCloseBtnText: this.$gettext('Close')
                  }
                  this.theCheckedAddress = {}
                  this.$root.$children[0].$refs.simplert.openSimplert(obj)
                  return false
                }
              } else {
                this.theCheckedAddress = json
              }
              return await json
            })
          }
        }).catch(response => {
          let obj = {
            title: this.$gettext('ERROR'),
            message: this.$gettext('The address is not accurate enough or is incorrect.'),
            type: 'error',
            customCloseBtnText: this.$gettext('Close')
          }
          this.theCheckedAddress = {}
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    }
  }
}
